import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  FormLabel,
  Select,
  MenuItem,
  CircularProgress,
  Tooltip,
  Hidden,
  Chip,
} from "@mui/material";
import { Scrollbars } from "rc-scrollbars";
import PublicResultsFooter from "./PublicResultsFooter";
// import ClubImage from "../../../assets/images/clubimage2.svg";
import Logo1 from "../../../assets/images/Logo1.png";
import Logo2 from "../../../assets/images/Logo2.png";
import Logo3 from "../../../assets/images/Logo3.png";
import Logo4 from "../../../assets/images/Logo4.png";
import FleetRaceTabs from "./FleetRaceTabsv2";
import ScrollableChipRow from "./ScrollableChipRow";
import {
  BACKEND_BASE_URL,
  EVENT_BANNER_PATH,
  EVENT_lOGO_PATH,
  SERIES_BANNER_PATH,
  SERIES_lOGO_PATH,
} from "../../global/constants";
import PublishResultsNoImage from "../../../components/PublishResultsNoImage";
import NoResultsPublished from "./NoResultsPublished";
import { encrypt } from "../../global/helperFunctions";
import CompanyLogo from "../../../assets/images/topyacht.svg";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Margin } from "@mui/icons-material";

const transitionBodyStyle = {
  transitionElement: {
    maxHeight: "0",
    overflow: "hidden",
    transition: "max-height 0.5s ease-in-out",
  },
  transitionElementExpanded: {
    maxHeight: "auto",
  },
};

const FleetRaceDetailsv2 = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [raceSessions, setRaceSessions] = useState([]);
  const [allRaceSessions, setAllRaceSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState("");
  const [selectedFleet, setSelectedFleet] = useState("");
  const [sessionLabel, setSessionLabel] = useState("");
  const [sessionNote, setSessionNote] = useState("");
  const [clubName, setClubName] = useState("");
  const [seriesName, setSeriesName] = useState("");
  const [seriesType, setSeriesType] = useState("");
  const [seriesId, setSeriesId] = useState("");
  const [results, setResults] = useState(null);
  const [banner, setBanner] = useState("");
  const [logos, setLogos] = useState([]);
  const [isSeriesScore, setIsSeriesScore] = useState(false);
  const [seriesScoreCols, setSeriesScoreCols] = useState([]);
  const queryParameter = new URLSearchParams(window.location.search);
  const seriesIdQ = queryParameter.get("seriesId");
  const [selectedFleetLabel, setSelectedFleetLabel] = useState("");
  const [resultOption, setResultOption] = useState("");
  const [loader, setLoader] = useState(false);
  const [isCasual, setIsCasual] = useState(false);
  const [isFetchingResults, setIsFetchingResults] = useState(false);
  const [activeFleet, setActiveFleet] = useState(null);
  const [activeRace, setActiveRace] = useState(null);

  const handleBackToIndex = () => {
    // navigate(-1);
    const origin = window.location.origin;
    const url = `${origin}/publicresults/SeriesIndex?seriesId=${seriesIdQ}`;
    window.location.href = url;
  };

  // Fleet chip click handler
  // Fleet chip click handler
  const handleFleetChipClick = (fleetId) => {
    if (props.paramExist) return;

    setActiveFleet(fleetId);
    setSelectedFleet(fleetId);

    const selectedFleetObj = props.fleetList.find(
      (f) => f.seriesFleetClassId === fleetId
    );
    setSelectedFleetLabel(selectedFleetObj ? selectedFleetObj.label : "");

    // Reset race selection
    setSelectedSession("");
    setActiveRace(null);
    setIsSeriesScore(false);
    setResults(null);
  };

  // Race chip click handler
  const handleRaceChipClick = (sessionId) => {
    if (props.paramExist) return;

    if (sessionId === -1) {
      setActiveRace(-1);
      setSelectedSession(-1);
      fetchSeriesScore();
    } else {
      setActiveRace(sessionId);
      setSelectedSession(sessionId);

      const selectedOption = raceSessions.find(
        (option) => option.sessionId === sessionId
      );
      const noSelectedOption = {
        sessionId: "",
        label: "",
      };
      setSessionLabel(selectedOption ? selectedOption : noSelectedOption);
      setIsSeriesScore(false);
      setResultOption("");
    }
  };

  useEffect(() => {
    if (props.raceSessions && props.raceSessions.length > 0) {
      setAllRaceSessions(props.raceSessions);
    }
  }, [props.raceSessions]);

  useEffect(() => {
    if (selectedFleet && allRaceSessions.length > 0) {
      // Coerce both sides to string: seriesFleetClassId arrives as a Number from
      // the API, but selectedFleet is a String when it comes from the URL's
      // fleetId query param (direct-link access) — a strict `===` between the
      // two never matches, silently leaving raceSessions empty forever on that
      // path. That in turn kept sessionLabel (passed to FleetRaceTabsv2 as
      // raceSession) unset, so columnOrder/hiddenColumns never had data to read.
      const filteredSessions = allRaceSessions.filter(
        (session) => String(session.seriesFleetClassId) === String(selectedFleet)
      );
      setRaceSessions(filteredSessions);

      setSelectedSession("");
      setActiveRace(null);

      // Fetch detailed sessions (with startTime) for the selected fleet
      const fetchDetailedSessions = async () => {
        try {
          const url =
            `${BACKEND_BASE_URL}api/PublishResults/clubs/raceSessions?seriesFleetClassId=` +
            selectedFleet;
          const response = await fetch(url);
          if (response.ok) {
            const result = await response.json();
            if (result.data && result.data.length > 0) {
              // Merge detailed data (startTime) while keeping original short labels for chips
              const merged = filteredSessions.map((fs) => {
                const detailed = result.data.find(
                  (ds) => ds.sessionId === fs.sessionId || ds.sessionId == fs.sessionId
                );
                return detailed
                  ? { ...detailed, chipLabel: fs.label }
                  : { ...fs, chipLabel: fs.label };
              });
              setRaceSessions(merged);
              // Update sessionLabel with detailed data if a session is already selected
              setSessionLabel((prev) => {
                if (!prev || !prev.sessionId) return prev;
                const updated = merged.find(
                  (s) => s.sessionId === prev.sessionId || s.sessionId == prev.sessionId
                );
                return updated ? updated : prev;
              });
            }
          }
        } catch (err) {
          // fallback to filtered sessions without startTime
        }
      };
      fetchDetailedSessions();
    }
  }, [selectedFleet, allRaceSessions]);


  const handleChange = async (event) => {
    const value = event.target.value;
    setSelectedSession(value);
    if (value != -1) {
      const selectedOption = raceSessions.find(
        (option) => option.sessionId === value
      );
      const noSelectedOption = {
        sessionId: "",
        label: "",
      };
      setSessionLabel(selectedOption ? selectedOption : noSelectedOption);
      setIsSeriesScore(false);
      setResultOption("");
    } else {
      fetchSeriesScore();
    }
  };

  useEffect(() => {
    if (props.raceSessionIdQ && raceSessions.length > 0) {
      const raceSessionOpt = raceSessions.find(
        (option) => option.sessionId == props.raceSessionIdQ
      );
      const noRaceSessionOpt = {
        sessionId: "",
        label: "",
        note: "",
      };
      setSessionLabel(raceSessionOpt ? raceSessionOpt : noRaceSessionOpt);
      setSelectedSession(props.raceSessionIdQ);
      setActiveRace(props.raceSessionIdQ);
      setSelectedFleetLabel(props.fleetName);
    }
  }, [props.raceSessionIdQ, raceSessions, props.fleetName]);

  useEffect(() => {
    if (resultOption && isSeriesScore) {
      const resultsByResultOption = results.resultGroupeds.find(
        (x) => x.resultOption == resultOption
      );

      console.log("resultsByResultOption", resultsByResultOption);
      if (!resultsByResultOption) {
        fetchSeriesScore();
      } else {
        setSeriesScoreCols(
          resultsByResultOption.columns.map((x) => {
            return {
              field: x,
              headerName: x.charAt(0).toUpperCase() + x.slice(1).toLowerCase(),
              // width:
              //   x.toLowerCase() === "boatname" || x.toLowerCase() === "sailnum"
              //     ? 100
              //     : 70,
              cellClassName: `${x}-cell`,
              // editable: true,
            };
          })
        );
      }
    }
  }, [resultOption, isSeriesScore, results]);

  const fetchSeriesScore = async () => {
    setIsSeriesScore(true);
    const encryptedSeriesId = seriesId; //encodeURIComponent(encrypt(JSON.stringify(seriesId)));
    const encryptedSelectedFleet = selectedFleet; //encodeURIComponent(encrypt(JSON.stringify(selectedFleet)));

    try {
      setLoader(true);
      const url =
        `${BACKEND_BASE_URL}api/PublishResults/clubs/getSeriesScores?seriesId=` +
        encryptedSeriesId +
        `&fleetId=` +
        encryptedSelectedFleet +
        `&resultOption=${resultOption}`; // if empty resultOption then will fetch the first one
      const response = await fetch(url);

      if (!response.ok) {
        setResults([]);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      resultOption
        ? setResults((prevResults) => {
          const updatedResults = prevResults
            ? {
              ...prevResults,
              resultGroupeds: [
                ...prevResults.resultGroupeds,
                ...result.data.resultGroupeds,
              ],
            }
            : result.data;
          return updatedResults;
        })
        : setResults(result.data);
      const resultsByResultOption =
        result.data.resultGroupeds.find(
          (x) => x.resultOption == resultOption
        ) || result.data.resultGroupeds[0];
      result.data.resultGroupeds.length > 0
        ? setSeriesScoreCols(
          resultsByResultOption.columns.map((x) => {
            const columnName = x.toLowerCase(); // Case-insensitive check
            const isSpecialColumn = [
              "place",
              "ties",
              "score",
              "sailnum",
            ].includes(columnName);
            return {
              field: x,
              cellClassName: `${x}-cell`,
              headerName:
                x.charAt(0).toUpperCase() + x.slice(1).toLowerCase(),
              // width: 70, // 70px for Place/Ties/Score, 100px for others
              // editable: true,
              renderCell: (params) => (
                <Tooltip
                  title={params?.value}
                  enterTouchDelay={0}
                  leaveTouchDelay={3000}
                >
                  <Typography
                    noWrap
                    style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                    variant="p"
                  >
                    {params.value}
                  </Typography>
                </Tooltip>
              ),
            };
          })
        )
        : setSeriesScoreCols([]);
    } catch (err) {
      //   setError(err.message); // Handle errors
    } finally {
      setIsLoaded(true);
      setLoader(false);
      //  setLoading(false); // Mark loading as complete
    }
  };

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (props.fleetList.length > 0) {
      setClubName(props.fleetList[0].clubName);
      setSeriesName(props.fleetList[0].seriesName);
      setSeriesType(props.fleetList[0].type);
      setSeriesId(props.fleetList[0].seriesId);
      setBanner(
        props.fleetList[0].banner
          ? SERIES_BANNER_PATH + props.fleetList[0].banner
          : props.fleetList[0].eventBanner
            ? EVENT_BANNER_PATH + props.fleetList[0].eventBanner
            : ""
      );
      setLogos(
        props.fleetList[0].logos
          ? props.fleetList[0].logos.split(",").map((x) => SERIES_lOGO_PATH + x)
          : props.fleetList[0].eventLogos
            ? props.fleetList[0].eventLogos
              .split(",")
              .map((x) => EVENT_lOGO_PATH + x)
            : []
      );
    }
  }, [props.fleetList]);

  // Auto-select first race when sessions are loaded
  // Auto-select first race when sessions are loaded
  useEffect(() => {
    if (
      raceSessions &&
      raceSessions.length > 0 &&
      !props.raceSessionIdQ &&
      !selectedSession &&
      selectedFleet  // Make sure fleet is selected first
    ) {
      const firstRace = [...raceSessions].reverse()[0];
      if (firstRace) {
        setSelectedSession(firstRace.sessionId);
        setActiveRace(firstRace.sessionId);
        setSessionLabel(firstRace);
      }
    }
  }, [raceSessions, props.raceSessionIdQ, selectedSession, selectedFleet]);

  const fetchResults = async (selectedFleet, selectedSession) => {
    setIsLoaded(false);
    setIsFetchingResults(true);
    try {
      const encryptedSeriesId = seriesId; //encodeURIComponent(encrypt(JSON.stringify(seriesId)));
      const encryptedSelectedFleet = selectedFleet; //encodeURIComponent(encrypt(JSON.stringify(selectedFleet)));
      const encryptedSelectedSession = selectedSession; //encodeURIComponent(encrypt(JSON.stringify(selectedSession)));

      // Construct the full URL
      const url =
        `${BACKEND_BASE_URL}api/PublishResults/clubs/raceResults?seriesId=` +
        encryptedSeriesId +
        `&fleetId=` +
        encryptedSelectedFleet +
        `&raceSessionId=` +
        encryptedSelectedSession;
      const response = await fetch(url);

      if (!response.ok) {
        setResults([]);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setResults(result.data); // Store API response in state
      console.log("THE data", result.data.resultGroupeds[0].results[0].eventId)
      fetchCasualFlag(result?.data?.resultGroupeds[0]?.results[0]?.eventId)

    } catch (err) {
      //   setError(err.message); // Handle errors
    } finally {
      setIsLoaded(true);
      setIsFetchingResults(false);
      //  setLoading(false); // Mark loading as complete
    }
  };

  useEffect(() => {
    console.log("The Race Session selected", selectedSession);
    setIsLoaded(false);
    if (props.fleetIdQ && props.raceSessionIdQ && seriesId && !isSeriesScore) {
      fetchResults(props.fleetIdQ, props.raceSessionIdQ);
    } else if (
      selectedSession != "" &&
      !props.fleetIdQ &&
      !props.raceSessionIdQ &&
      seriesId &&
      !isSeriesScore
    ) {
      fetchResults(selectedFleet, selectedSession);
    }
  }, [
    selectedSession,
    props.fleetIdQ,
    props.raceSessionIdQ,
    seriesId,
    isSeriesScore,
    selectedFleet,
  ]);

  const fetchCasualFlag = async (eventId) => {
    try {
      const response = await fetch(`${BACKEND_BASE_URL}api/PublishResults/clubs/${eventId}/isCasual`);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("THE casual", data)
      setIsCasual(data);
    } catch (err) {
      console.error("Error fetching isCasual flag:", err);
    }
  };

  // Initial fleet selection - runs only once on mount or when props change
  useEffect(() => {
    // Don't override if user has already selected a fleet manually
    if (activeFleet) return;

    if (props.fleetIdQ) {
      setSelectedFleet(props.fleetIdQ);
      setActiveFleet(props.fleetIdQ);
    } else if (props.fleet && props.fleet.seriesFleetClassId) {
      setSelectedFleet(props.fleet.seriesFleetClassId);
      setActiveFleet(props.fleet.seriesFleetClassId);
      setSelectedFleetLabel(props.fleet.label);
    } else if (props.fleetList && props.fleetList.length > 0) {
      const firstFleet = props.fleetList[0];
      setSelectedFleet(firstFleet.seriesFleetClassId);
      setActiveFleet(firstFleet.seriesFleetClassId);
      setSelectedFleetLabel(firstFleet.label);
    }
  }, [props.fleet, props.fleetIdQ, props.fleetList]); // ✅ Remove selectedFleet from dependencies

  return (
    <div className="ty_public_results_main ty_application_design" style={{ overflowX: 'hidden', width: '100%' }}>
      <Box className="inner_wrapper_pages" sx={{ overflowX: 'hidden', width: '100%' }}>
        <Box className="InnerPage_area" sx={{ overflowX: 'hidden', width: '100%' }}>
          <Scrollbars
            autoHide
            // autoHeight
            // autoHeightMin={"calc(100vh - 180px)"}
            style={{
              width: "100%",
              height: '100%',
              overflowX: 'hidden',
            }}
          >
            {!isLoaded ? (
              <Box sx={{ height: '100%', width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress sx={{ color: "var(--ty-primary-color)" }} size={80} />
              </Box>
            ) : (
              <Box className="ty_public_results">
                <Grid mb={1} container className="ty_pr_main_container">
                  <Grid item lg={12} xs={12} sx={{ padding: "0" }}>
                    <Box
                      sx={{
                        paddingX: { xs: "0.5rem", sm: "1rem" },
                        position: "relative",
                      }}
                    >
                      {/* Back Button */}
                      <Box
                        sx={{
                          position: "absolute",
                          left: { xs: "0.3rem", sm: "0.9rem" },
                          top: banner
                            ? { xs: "2.0rem", sm: "2.7rem" }
                            : { xs: "5.9rem", sm: "5.4rem" },
                          zIndex: 10,
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={handleBackToIndex}
                          sx={{
                            minWidth: { xs: "28px", sm: "32px" },
                            width: { xs: "28px", sm: "32px" },
                            height: { xs: "28px", sm: "32px" },
                            padding: 0,
                            borderRadius: "50%",
                            backgroundColor: "#356dad",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                            "&:hover": {
                              backgroundColor: "#115293",
                            },
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <ArrowBackIcon sx={{ fontSize: { xs: "16px", sm: "18px" } }} />
                        </Button>
                      </Box>

                      {/* Banner/Image Section */}
                      <Box
                        sx={{
                          textAlign: "center",
                          fontSize: { xs: "1.2rem", sm: "1.5rem" },
                          fontWeight: 600,
                          color: "#356dad",
                          paddingTop: { xs: "0.5rem", sm: "0" },
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: "100%",
                            minHeight: { xs: "70px", sm: "85px", md: "100px" },
                            ...(props.isLoggedOutMode ? { marginTop: "0.5rem" } : {}),
                          }}
                        >
                          {banner ? (
                            <img
                              src={banner}
                              alt="club image"
                              className="ty_pr_club_image"
                              style={{
                                maxHeight: "100px",
                                width: "75%",
                                maxWidth: "350px",
                                height: "auto",
                                objectFit: "contain",
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: "center",
                                width: "100%",
                                minHeight: { xs: "70px", sm: "80px" },
                              }}
                              className="BannerHandler"
                            >
                              <PublishResultsNoImage
                                tagName={"Banner"}
                                boxWidth={"20%"}
                                boxHeight={"80px"}
                              />
                            </Box>
                          )}
                        </Box>
                      </Box>

                      <div style={{ textAlign: 'center' }}>
                        <Typography mt={1} className="ty_pr_series_caption_text">
                          {seriesName}
                        </Typography>
                        <Typography className="ty_pr_heading_text">
                          Hosted by <>{clubName}</>
                        </Typography>
                      </div>
                      
                      {/* Horizontal Line */}
                      <Box
                        sx={{
                          height: "2px",
                          width: "100%",
                          backgroundColor: "#dee3e5",
                          marginTop: "0.2rem",
                        }}
                      /> 
                    </Box>
                  </Grid>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    xs={12}
                    pt={1}
                    sx={{ justifyItems: "center", paddingTop: '0' }}
                  >
                    <Grid container className="ty_pr_container" >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        xs={12}
                        pt={1}
                        sx={{ justifyItems: "center" }}
                      >
                        <Box
                          style={{
                            ...transitionBodyStyle.transitionElement,
                            ...(isLoaded
                              ? transitionBodyStyle.transitionElementExpanded
                              : {}),
                          }}
                          sx={{
                            width: '100%',
                          }}
                        >
                          {isFetchingResults ? (
                            <div style={{ padding: "24px 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                              <CircularProgress sx={{ color: "#fff" }} size={40} />
                            </div>
                          ) : (!results || (results && (!results.resultGroupeds || results.resultGroupeds.length === 0))) && props.fleetIdQ && props.raceSessionIdQ ? (
                            <div style={{ padding: "24px 0" }}>
                              <NoResultsPublished />
                            </div>
                          ) : (
                            <Grid container className="ty_pr_table_container" sx={{
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: { xs: "0 0.5rem !important", sm: "0 0.5rem !important", md: "0 0.75rem !important", lg: "0 1.5rem !important", xl: "0 1.5rem !important" }
                            }}>
                              <Grid item xs={12} lg={12} >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    padding: "0 0",
                                    marginBottom: '10px',
                                  }}
                                >
                                </Box>

                                <Box>
                                  <FormLabel
                                    className="ty-uppercase-label"
                                    variant="h6"
                                    sx={{
                                      display: "block",
                                      textAlign: "Left",
                                      fontWeight: "bold",
                                      marginLeft: "3px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    Fleet
                                  </FormLabel>
                                  <ScrollableChipRow>
                                    {props.fleetList?.length > 0 &&
                                      props.fleetList.map((f) => (
                                        <Chip
                                          key={f.seriesFleetClassId}
                                          label={f.label}
                                          onClick={() => handleFleetChipClick(f.seriesFleetClassId)}
                                          disabled={props.paramExist}
                                          sx={{
                                            backgroundColor:
                                              String(activeFleet) === String(f.seriesFleetClassId)
                                                ? "#356dad !important"
                                                : "rgba(0,0,0,0.05)",
                                            color:
                                              String(activeFleet) === String(f.seriesFleetClassId) ? "#fff !important" : "#356dad !important",
                                            border: "1px solid #356dad",
                                            fontSize: "0.8rem",
                                            height: "28px",
                                            flexShrink: 0,
                                            cursor: props.paramExist ? "default" : "pointer",
                                            "&:hover": {
                                              backgroundColor: props.paramExist
                                                ? (String(activeFleet) === String(f.seriesFleetClassId) ? "#356dad !important" : "rgba(0,0,0,0.05)  !important")
                                                : (String(activeFleet) === String(f.seriesFleetClassId)
                                                  ? "#356dad !important"
                                                  : "rgba(0,0,0,0.1) !important"),
                                            },
                                          }}
                                        />
                                      ))}
                                  </ScrollableChipRow>
                                </Box>

                                {raceSessions && raceSessions.length > 0 && (
                                  <Box>
                                    <ScrollableChipRow sx={{ marginBottom: "15px" }}>
                                      <Chip
                                        key={-1}
                                        label="Series Score"
                                        onClick={() => handleRaceChipClick(-1)}
                                        disabled={props.paramExist}
                                        sx={{
                                          backgroundColor:
                                            activeRace === -1
                                              ? "#356dad !important"
                                              : "rgba(0,0,0,0.05) !important",
                                          color:
                                            activeRace === -1 ? "#fff !important" : "#356dad !important",
                                          border: "1px solid #356dad",
                                          fontSize: "0.8rem",
                                          height: "28px",
                                          flexShrink: 0,
                                          cursor: props.paramExist ? "default" : "pointer",
                                          "&:hover": {
                                            backgroundColor: props.paramExist
                                              ? (activeRace === -1 ? "#356dad !important" : "rgba(0,0,0,0.05) !important")
                                              : (activeRace === -1
                                                ? "#356dad !important"
                                                : "rgba(0,0,0,0.1) !important"),
                                          },
                                        }}
                                      />
                                      {[...(raceSessions || [])].reverse().map((rs) => (
                                        <Chip
                                          key={rs.sessionId}
                                          label={rs.chipLabel || rs.label}
                                          onClick={() => handleRaceChipClick(rs.sessionId)}
                                          disabled={props.paramExist}
                                          sx={{
                                            backgroundColor:
                                              String(activeRace) === String(rs.sessionId)
                                                ? "#356dad !important"
                                                : "rgba(0,0,0,0.05) !important",
                                            color:
                                              String(activeRace) === String(rs.sessionId) ? "#fff !important" : "#356dad !important",
                                            border: "1px solid #356dad",
                                            fontSize: "0.8rem",
                                            height: "28px",
                                            flexShrink: 0,
                                            cursor: props.paramExist ? "default" : "pointer",
                                            "&:hover": {
                                              backgroundColor: props.paramExist
                                                ? (String(activeRace) === String(rs.sessionId) ? "#356dad !important" : "rgba(0,0,0,0.05) !important")
                                                : (String(activeRace) === String(rs.sessionId)
                                                  ? "#356dad !important"
                                                  : "rgba(0,0,0,0.1) !important"),
                                            },
                                          }}
                                        />
                                      ))}
                                    </ScrollableChipRow>
                                  </Box>
                                )}
                              </Grid>
                              <Grid item xs={12} lg={12} >
                                <Box sx={{ width: "100%", maxWidth: "100%" }}>
                                  <FleetRaceTabs
                                    results={results}
                                    isSeriesScore={isSeriesScore}
                                    seriesScoreCols={seriesScoreCols}
                                    selectedFleetLabel={selectedFleetLabel}
                                    setResultOption={(value) => setResultOption(value)}
                                    loader={loader}
                                    seriesType={seriesType}
                                    isCasual={isCasual}
                                    raceSession={sessionLabel}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container>
                  {logos?.length > 0 ?
                    <Grid mt={1} item xs={12}>
                      <PublicResultsFooter
                        footerLogos={logos}
                        footerBannerImage={banner}
                      />
                    </Grid>
                    : ""}
                  <Box
                    sx={{
                      p: 1,
                      width: '100%',
                    }}
                    className="ty_pr_StikcyFooter"
                  >
                    <Typography className="result-by">Results By </Typography>
                    <img
                      src={CompanyLogo}
                      alt="Banner"
                      style={{
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Grid>
              </Box>
            )}
          </Scrollbars>
        </Box>
      </Box>
    </div>
  );
};

export default FleetRaceDetailsv2;
